import React, { useMemo } from 'react';
import moment from 'moment-jalaali';
import PersianDatePicker from '../PersianDatePicker';

const QUICK_OPTIONS = [
  { key: 'today', label: 'امروز', days: 0 },
  { key: 'tomorrow', label: 'فردا', days: 1 },
  { key: 'three_days', label: 'سه روز بعد', days: 3 },
  { key: 'next_week', label: 'هفته بعد', days: 7 },
];

const toLatinDigits = (value) => {
  if (value == null) return '';
  const persian = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
  let result = String(value);
  persian.forEach((digit, index) => {
    result = result.replace(new RegExp(digit, 'g'), String(index));
  });
  return result;
};

const normalizePickerValue = (value) => {
  if (!value) return null;
  if (typeof value === 'string') return toLatinDigits(value.trim());
  if (value?.format && typeof value.format === 'function') {
    return toLatinDigits(value.format('YYYY/MM/DD HH:mm'));
  }
  return null;
};

const detectActiveQuickKey = (value) => {
  const normalized = normalizePickerValue(value);
  if (!normalized) return null;

  const parsed = moment(normalized, ['jYYYY/jMM/jDD HH:mm', 'YYYY/MM/DD HH:mm'], true);
  if (!parsed.isValid()) return null;

  const targetDay = parsed.clone().startOf('day');
  const today = moment().startOf('day');

  for (const option of QUICK_OPTIONS) {
    const expected = today.clone().add(option.days, 'days').startOf('day');
    if (targetDay.isSame(expected, 'day')) return option.key;
  }
  return null;
};

/**
 * انتخابگر تاریخ پیگیری با میانبرهای «امروز»، «فردا»، «سه روز بعد»، «هفته بعد»
 */
const FollowUpSchedulePicker = ({ value, onChange, showTime = true, style, placeholder }) => {
  const activeKey = useMemo(() => detectActiveQuickKey(value), [value]);

  const handleQuickSelect = (days) => {
    const next = moment().add(days, 'days').hour(10).minute(0).second(0);
    onChange?.(next.format('jYYYY/jMM/jDD HH:mm'));
  };

  return (
    <div className="space-y-3">
      <div className="flex flex-wrap gap-2">
        {QUICK_OPTIONS.map((option) => {
          const isActive = activeKey === option.key;
          return (
            <button
              key={option.key}
              type="button"
              onClick={() => handleQuickSelect(option.days)}
              className={[
                'px-3 py-1.5 text-xs rounded-full border transition-all duration-200',
                'focus:outline-none focus-visible:ring-2 focus-visible:ring-teal-500/40',
                isActive
                  ? 'bg-teal-600 text-white border-teal-600 shadow-sm'
                  : 'bg-white dark:bg-gray-800 text-gray-600 dark:text-gray-300 border-gray-200 dark:border-gray-600 hover:border-teal-400 hover:text-teal-700 dark:hover:text-teal-300',
              ].join(' ')}
              style={{ fontFamily: 'CustomFont' }}
            >
              {option.label}
            </button>
          );
        })}
      </div>
      <PersianDatePicker
        value={value}
        onChange={onChange}
        showTime={showTime}
        placeholder={placeholder || 'انتخاب تاریخ و زمان'}
        style={{ width: '100%', ...style }}
      />
    </div>
  );
};

export default FollowUpSchedulePicker;
